import { KEYS } from '../../constants/keys';
import { isValidateDynamicBundle } from '../../dynamicBundle';
import {
  DROPDOWN_SELECT_OPTION_SELECTED,
  RECOMMENDATION_SELECTOR,
  VOLUME_BUTTON_ADD_BUNDLE_TO_CART_SELECTOR,
} from '../constants';
import { addVolumeBundleToCart } from '../services/bundle-data';
import { closeAllDropdown, handleDropdownToggle, selectVariantProduct } from './dropdown-events';
import {
  closeVolumeBundleModal,
  createVolumeBundleModalContainer,
  openVolumeBundleModal,
} from './modal-events';
import { initBasicEventsForVolumeBundle } from './radio-events';

/**
 * @type {import('../index.d').handleClickVolumeBundle}
 */
export const handleClickVolumeBundle = (context, target) => {
  const widgetId = target
    ?.closest('.boost-sd__volume-bundle-product-item')
    ?.getAttribute('data-widget-id');
  widgetId && openVolumeBundleModal(context, widgetId);
};

/**
 * @type {import('../index.d').initVolumeBundle}
 */
export const initVolumeBundle = (context) => {
  if (!isValidateDynamicBundle(context)) return;

  const isBlockShowModal = context.blockType === 'instantSearch';
  const position = 'isw';

  if (isBlockShowModal) {
    registerEventBundleModal(context, context.document, position);
  }
};

/**
 * @type {import('../index.d').registerEventBundle}
 */
export const registerEventBundle = (context, targetElement, position) => {
  if (!targetElement || !(targetElement instanceof HTMLElement)) return;

  if (targetElement.dataset.bundleEventsBound === 'true') return;
  targetElement.dataset.bundleEventsBound = 'true';

  targetElement.addEventListener('click', (event) => {
    const target = event.target;
    initBasicEventsForVolumeBundle(context, target, event, targetElement, position);

    if (target?.closest(VOLUME_BUTTON_ADD_BUNDLE_TO_CART_SELECTOR)) {
      addVolumeBundleToCart(context, target);
    }
  });

  targetElement.addEventListener('keydown', (event) => {
    handleVolumeComboboxNavigation(event, context, targetElement, position);

    const target = event.target;
    if (KEYS.includes(event.key)) {
      if (target?.closest(VOLUME_BUTTON_ADD_BUNDLE_TO_CART_SELECTOR)) {
        addVolumeBundleToCart(context, target);
      }

      const combobox = target?.closest('.boost-sd__dropdown-volume');
      handleDropdownToggle(target, combobox);
    }
  });
};

/**
 * @type {import('../index.d').registerEventBundleModal}
 */
export const registerEventBundleModal = (context, domEvent, position) => {
  if (!domEvent || !(domEvent instanceof HTMLElement)) return;
  if (domEvent.dataset.bundleEventsBound === 'true') return;
  domEvent.dataset.bundleEventsBound = 'true';

  createVolumeBundleModalContainer(context, position);

  domEvent?.addEventListener('click', function (event) {
    const target = event.target;

    initBasicEventsForVolumeBundle(context, target, event, domEvent, position);
  });
};

/**
 * @type {import('../index.d').handleVolumeComboboxNavigation}
 */
const handleVolumeComboboxNavigation = (event, context, container, position) => {
  const target = event.target;
  const combobox = target?.closest('.boost-sd__dropdown-volume');
  if (!combobox) return;

  const expanded = combobox.getAttribute('aria-expanded') === 'true';
  const comboboxList = combobox?.querySelector('[role="listbox"]');
  const comboboxItems = comboboxList?.querySelectorAll('[role="option"]');
  let selectedIndex = Array.from(comboboxItems).findIndex((item) =>
    item.classList.contains(DROPDOWN_SELECT_OPTION_SELECTED)
  );

  const isArrowUp = event.key === 'ArrowUp';
  const isArrowDown = event.key === 'ArrowDown';
  const isEscPressed = event.key === 'Escape' || event.keyCode === 27;

  if (expanded && (isArrowUp || isArrowDown)) {
    event.preventDefault();
    selectedIndex = isArrowDown
      ? (selectedIndex + 1) % comboboxItems.length
      : (selectedIndex - 1 + comboboxItems.length) % comboboxItems.length;
    comboboxItems.forEach((item) => item.classList.remove(DROPDOWN_SELECT_OPTION_SELECTED));
    comboboxItems[selectedIndex].classList.add(DROPDOWN_SELECT_OPTION_SELECTED);
    combobox.setAttribute('aria-activedescendant', comboboxItems[selectedIndex].id);
    comboboxItems[selectedIndex].scrollIntoView({ block: 'nearest' });
    comboboxItems[selectedIndex].focus();
  }

  if (expanded && KEYS.includes(event.key)) {
    selectVariantProduct(context, target, container, position);
  }

  if (expanded && isEscPressed) {
    combobox.setAttribute('aria-expanded', 'false');
    closeAllDropdown();
  }
};

/**
 * @type {import('../index.d').addEventListenersToCombobox}
 */
export const addEventListenersToCombobox = (element, context) => {
  element.addEventListener('keydown', (event) =>
    handleVolumeComboboxNavigation(event, context, element, position)
  );
};

/**
 * @type {import('../index.d').handleVolumeModalEvents}
 */
export const handleVolumeModalEvents = (event, context, bundleModal, position) => {
  const target = event.target;
  initBasicEventsForVolumeBundle(context, target, event, bundleModal, position);

  if (target?.closest(VOLUME_BUTTON_ADD_BUNDLE_TO_CART_SELECTOR)) {
    addVolumeBundleToCart(context, target);
  }

  if (
    (!target?.closest(RECOMMENDATION_SELECTOR) &&
      !target?.closest('.boost-sd__volume-bundle-product-item')) ||
    target?.closest('.boost-sd__volume-bundle-modal-close')
  ) {
    closeVolumeBundleModal(context);
  }
};

window.addEventListener('boost-sd-open-volume-bundle', function openVolumeModal(e) {
  if (e?.detail?.widgetId && e?.detail?.context)
    openVolumeBundleModal(e.detail.context, e.detail.widgetId);
});
